import { createElement } from 'react'

import { Box, Icon, Table, Text, colors } from '@factorialco/deprecated-design-system'

import { CustomTooltip } from '../../../../CustomTooltip'
import { dashedRowProps, stickyColumnProps } from '../../../const'
import { STICKY_CELL_WIDTH, WEIGHT } from '../const'

interface Props {
  title: string
  level?: number
  grey?: boolean
  italic?: boolean
  dashed?: boolean
  tooltip?: string
  subLabel?: string
  children?: React.ReactNode
  hasSiblingWithChildren?: boolean
  parentHasGrandChildren?: boolean
  titleWrapper?: React.FC<{ children: React.ReactNode }>
}

const PADDING_LEFT: Record<number, number> = {
  0: 24,
  1: 44,
  2: 64,
}

export const StickyCell = ({
  grey,
  title,
  italic,
  dashed,
  tooltip,
  children,
  subLabel,
  level = 0,
  titleWrapper,
  hasSiblingWithChildren,
}: Props) => {
  const Title = tooltip ? (
    <Box flexDirection="row" gap="s4" alignItems="center">
      {title}
      {tooltip && (
        <CustomTooltip label={tooltip}>
          <Icon.Medium icon="info-circle-line" color={grey ? 'grey700' : 'grey1000'} />
        </CustomTooltip>
      )}
    </Box>
  ) : (
    title
  )

  return (
    <Table.Cell
      sticky={stickyColumnProps}
      rowClickable
      wide
      style={{
        width: STICKY_CELL_WIDTH,
        minWidth: STICKY_CELL_WIDTH,
        paddingLeft: PADDING_LEFT[level]
          ? `${PADDING_LEFT[level] + (hasSiblingWithChildren ? 21 : 0)}px`
          : undefined,
        ...(grey ? { backgroundColor: colors.grey100 } : {}),
        ...(dashed ? dashedRowProps : {}),
      }}
    >
      <Box flexDirection="column">
        <Text.Normal
          ellipsis
          size="200"
          weight={WEIGHT[level]}
          color={grey ? 'grey800' : 'grey1000'}
          fontStyle={italic ? 'italic' : 'normal'}
        >
          {titleWrapper ? createElement(titleWrapper, undefined, Title) : Title}
        </Text.Normal>
        {subLabel ? (
          <Text.Normal
            ellipsis
            size="200"
            weight={WEIGHT[level]}
            color={grey ? 'grey800' : 'grey1000'}
            fontStyle={italic ? 'italic' : 'normal'}
          >
            {subLabel}
          </Text.Normal>
        ) : null}
        {children}
      </Box>
    </Table.Cell>
  )
}
